import Vue from "vue";

import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

if (process.env.NODE_ENV === "production") {
	Sentry.init({
		Vue,
		dsn: "https://aff5ff478a2e4c6badb996273c14c174@o326214.ingest.sentry.io/5609370",
		autoSessionTracking: true,
		logErrors: true,
		tracesSampleRate: 1.0,
		environment: process.env.NODE_ENV,
		integrations: [
			new Integrations.BrowserTracing()
			/*new SentryRRWeb({
				recordLog: true
				collectFonts: true,
				recordCanvas: true
			})*/
		],
		tracingOptions: {
			trackComponents: true
		}
	});
}

import App from "./App.vue";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css"; // Vuesax
import "material-icons/iconfont/material-icons.css";

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Vue i18n
import i18n from "./i18n";

// VeeValidate
import VeeValidate from "vee-validate";

import VueInputAutowidth from "vue-input-autowidth";

Vue.use(Vuesax);
Vue.use(VeeValidate);
Vue.use(VueInputAutowidth);

// Feather font icon
require("./assets/css/iconfont.css");

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount("#app");
